import modulePublicPaymentsState from '@/store/publicStore/payments/modulePublicPaymentsState'
import modulePublicPaymentsMutations from '@/store/publicStore/payments/modulePublicPaymentsMutations'
import modulePublicPaymentsActions from '@/store/publicStore/payments/modulePublicPaymentsActions'
import modulePublicPaymentsGetters from '@/store/publicStore/payments/modulePublicPaymentsGetters'
import modulePublicReservationState from '@/store/publicStore/reservation/modulePublicReservationState'
import modulePublicReservationMutations from '@/store/publicStore/reservation/modulePublicReservationMutations'

export default {
  namespaced: true,
  state: { ...modulePublicPaymentsState, ...modulePublicReservationState },
  mutations: { ...modulePublicPaymentsMutations, ...modulePublicReservationMutations },
  actions: { ...modulePublicPaymentsActions },
  getters: { ...modulePublicPaymentsGetters },
}
